module.exports = __webpack_public_path__ + "img/NewsCenterDetails7_pic5.1a8e90c9.png";